import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import { ARENA_ICONS } from '../../common';
export default class OverrideHistoryModal extends Modal {
  loading = true;
  entries = [];
  className() {
    return 'OverrideHistoryModal Modal--medium';
  }
  title() {
    return m('[', null, m("i", {
      className: "fas fa-history"
    }), ' ', app.translator.trans('forumaker-arena.forum.override_history.title', {
      username: this.attrs.username
    }));
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loadLog();
  }
  async loadLog() {
    this.loading = true;
    m.redraw();
    try {
      const resp = await app.request({
        method: 'GET',
        url: `${app.forum.attribute('apiUrl')}/arena/users/${this.attrs.userId}/override-log`
      });
      this.entries = resp.data ?? [];
    } catch {
      // fail silently
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  fieldLabel(field) {
    if (field === 'max_hp') return m('[', null, m("i", {
      className: ARENA_ICONS.hp,
      style: {
        color: 'var(--arena-hp)'
      }
    }), " ", app.translator.trans('forumaker-arena.forum.override_history.field_max_hp'));
    if (field === 'max_mana') return m('[', null, m("i", {
      className: ARENA_ICONS.mana,
      style: {
        color: 'var(--arena-mana)'
      }
    }), " ", app.translator.trans('forumaker-arena.forum.override_history.field_max_mana'));
    return field;
  }
  formatDate(iso) {
    const utcStr = iso.includes('T') ? iso : iso.replace(' ', 'T') + 'Z';
    const d = new Date(utcStr);
    return d.toLocaleString(app.locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }
  content() {
    if (this.loading) {
      return m("div", {
        className: "Modal-body OverrideHistoryModal-body"
      }, m(LoadingIndicator, null));
    }
    const defaultBadge = m("span", {
      className: "OverrideHistoryModal-default"
    }, app.translator.trans('forumaker-arena.forum.override_history.default_value'));
    return m("div", {
      className: "Modal-body OverrideHistoryModal-body"
    }, this.entries.length === 0 ? m("div", {
      className: "OverrideHistoryModal-empty"
    }, m("i", {
      className: "fas fa-inbox"
    }), " ", app.translator.trans('forumaker-arena.forum.override_history.empty')) : m("table", {
      className: "OverrideHistoryModal-table"
    }, m("thead", null, m("tr", null, m("th", null, app.translator.trans('forumaker-arena.forum.override_history.col_date')), m("th", null, app.translator.trans('forumaker-arena.forum.override_history.col_field')), m("th", null, app.translator.trans('forumaker-arena.forum.override_history.col_old')), m("th", null, app.translator.trans('forumaker-arena.forum.override_history.col_new')), m("th", null, app.translator.trans('forumaker-arena.forum.override_history.col_actor')))), m("tbody", null, this.entries.map(e => m("tr", {
      key: e.id
    }, m("td", {
      className: "OverrideHistoryModal-date"
    }, this.formatDate(e.createdAt)), m("td", null, this.fieldLabel(e.field)), m("td", {
      className: "OverrideHistoryModal-old"
    }, e.oldValue ?? defaultBadge), m("td", {
      className: "OverrideHistoryModal-new"
    }, e.newValue ?? defaultBadge), m("td", null, e.actorName))))), m("div", {
      className: "OverrideHistoryModal-footer"
    }, m(Button, {
      className: "Button",
      onclick: () => this.hide()
    }, app.translator.trans('forumaker-arena.forum.override_history.close_btn'))));
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/OverrideHistoryModal', OverrideHistoryModal);